import { ObservableService } from "../services/ObservableService";

const initialState = {};

export const tableDimensionsStore = ObservableService.persistentObservable(
  "tableDimensionsStore",
  () => initialState,
  3600
);
